import _styled from "@emotion/styled/base";

var TitleWrapper = /*#__PURE__*/_styled("div", true ? {
  target: "e16ehyoi0"
} : {
  target: "e16ehyoi0",
  label: "TitleWrapper"
})(true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvQWNjb3JkaW9uL1RpdGxlV3JhcHBlci9UaXRsZVdyYXBwZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUUrQiIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL0FjY29yZGlvbi9UaXRsZVdyYXBwZXIvVGl0bGVXcmFwcGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5jb25zdCBUaXRsZVdyYXBwZXIgPSBzdHlsZWQuZGl2YGBcblxuZXhwb3J0IGRlZmF1bHQgVGl0bGVXcmFwcGVyXG4iXX0= */");

export default TitleWrapper;